const state = {
    msgErrorReportes: '',
    reportesFormModel: {
        inDate1:       {model:"2022-01-01"},
        inDate2:       {model:"2022-01-01"},
        inRadioButton: {model:"", options:['Vigente', 'Cancelado']},
        inSelectUser:  {title:"Usuario:", modelArr:[]},
        inSelectOficinaDirDepto : {title:"Oficina:", model:''},
        inChk :         {title: "T", model:false},
        inSelectTipoReporte: "Diario de Ingreso Detallado",
        inSelectConcepto:"BUSCAR EN TODOS LOS CONCEPTOS",
        inTipoFiltro:"Usuario",
    },
    //reporte:[ { "Catastro": "40,563,236", "Anuncios Publicos": "19,046,203", "Registro Civil": "32,305,606", "Rastros": "32,564,123"} ],
    isGenerando: false,
    catalogReportes: null,
    reporte:null,
}

// mutations
const mutations = {
    updateCatalogReportes(state, newCatalogReportes){
        state.catalogReportes = newCatalogReportes;
    },
    updateMsgErrorReportes (state, newMsgErrorReportes) {
        state.msgErrorReportes = newMsgErrorReportes;
    },
    updateReportesFormModel (state, newReportesFormModel) {
        state.reportesFormModel = newReportesFormModel;
    },
    updateReporte (state, newReporte) {
        state.reporte = newReporte;
    },
    updateIsGenerando (state, newIsGenerando) {
        state.isGenerando = newIsGenerando;
    },
}

export default {
    state,
    mutations
}